import { get, post, put, patch, del } from '../http/http';
// 设备管理
export default {
  getDeviceList: (val) => get('/device/deviceOverview', val), // 查询列表
  getList: (val) => get('/eqp', val), // 查询列表
  addList: (val) => post('/eqp', val), // 添加
  delList: (val) => del(`/eqp/${val}`), // 删除
  putList: (val) => put(`/eqp/${val.id}`, val), // 编辑
  release: (val) => patch(`/eqp/${val}`), // 上线
  getStatus: (val) => get('/eqp/check-status', val), // 检测设备
  getInfo: (val) => get('/eqp/info', val), // 查询设备信息
  getInstruction: (val) => get('/eqp/instruction', val), // 发送设备指令
  getParse: (val) => get('/eqp/parse', val), // 解析16进制数据
  getLog: (val) => get('/device/deviceCallLog', val), // 设备调用日志
  getDeviceReport: (val) => get('/device/deviceProductReport', val), // 设备调用报表
  exportReport: (val) =>
    get('/device/export/deviceCallLog', val, {
      responseType: 'blob'
    }) // 导出设备调用日志
};
